exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4d8833b4] .error-body div {\n  margin: 0;\n  margin-top: 20px;\n  padding: 10px;\n}\n.services-dashboard[data-v-4d8833b4]  .md-card {\n  margin-bottom: 0;\n}\n.default-price[data-v-4d8833b4] {\n  color: darkgray;\n}\n.cell-hover[data-v-4d8833b4] {\n  cursor: pointer;\n}\n", ""]);

// exports
